module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/logo-guard-global.9944f6ef.png";